import { chartAxes } from '../../constants/event';
import { sortingOptions, sortingOrder } from '../../constants/common';
import { getView, getViews } from '../../utils/event/common';

const columnChartSortingInitialState = {
  axis: chartAxes.Y,
  order: sortingOrder.DESCENDING,
  sortingOptions: sortingOptions.DEPEND,
};

const usageInitialState = {
  events: null,
  sessions: null,
  avgSessionLength: null,
  uniqueUsers: null,
  executeTime: 0,
  executing: false,
  executeId: '',
  options: {
    columnChartSorting: columnChartSortingInitialState,
    views: [],
    view: undefined,
    singleChartMode: true,
    showFormula: false,
    calcTotal: false,
    trendLine: false,
    averageLine: false,
    medianLine: false,
    showSortingOptions: false,
    enteredFormula: null,
    adaptive: false,
    isExpand: false,
  },
};

const execute = (state = usageInitialState, action) => {
  switch (action.type) {
    case 'EXECUTE_USAGE_QUERIES_SUCCESS':
      return {
        ...state,
        options: {
          ...state.options,
          view: getView(state.options.view, action.events),
          views: getViews(action.events),
          ...action.options,
        },
        events: action.events,
        sessions: action.sessions,
        avgSessionLength: action.avgSessionLength,
        uniqueUsers: action.uniqueUsers,
        executeTime: new Date().valueOf(),
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_USAGE_QUERIES_FAILURE':
      return {
        ...state,
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_USAGE_QUERIES':
      return {
        ...state,
        sessions: null,
        avgSessionLength: null,
        uniqueUsers: null,
        executing: true,
      };

    case 'SET_USAGE_EXECUTE_ID':
      return {
        ...state,
        executeId: action.executeId,
      };

    case 'CHANGE_USAGE_VIEW':
      return {
        ...state,
        options: {
          ...state.options,
          view: action.view,
          showFormula: false,
        },
      };

    case 'TOGGLE_USAGE_CALC_TOTAL':
      return {
        ...state,
        options: {
          ...state.options,
          calcTotal: !state.options.calcTotal,
        },
      };

    case 'TOGGLE_USAGE_TREND_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          trendLine: !state.options.trendLine,
        },
      };

    case 'TOGGLE_USAGE_AVERAGE_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          averageLine: !state.options.averageLine,
        },
      };

    case 'TOGGLE_USAGE_MEDIAN_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          medianLine: !state.options.medianLine,
        },
      };

    case 'TOGGLE_USAGE_ADAPTIVE':
      return {
        ...state,
        options: {
          ...state.options,
          adaptive: !state.options.adaptive,
        },
      };

    case 'CHANGE_USAGE_COLUMN_CHART_SORTING':
      return {
        ...state,
        options: {
          ...state.options,
          columnChartSorting: action.sorting,
        },
      };

    case 'USAGE_SET_EXPAND':
      return {
        ...state,
        options: {
          ...state.options,
          isExpand: action.value,
        },
      };

    default:
      return state;
  }
};

export default execute;

export const getEvents = (state) => state.events;

export const getSessions = (state) => state.sessions;

export const getAvgSessionLength = (state) => state.avgSessionLength;

export const getUniqueUsers = (state) => state.uniqueUsers;

export const getChartOptions = (state) => state.options;

export const getExecuteTime = (state) => state.executeTime;

export const isExecuting = (state) => state.executing;

export const getExecuteId = (state) => state.executeId;
